<script setup lang="ts">
import { match } from 'ts-pattern';
import type { TextSize } from './text';

type HeadingTag = `h${1 | 2 | 3 | 4 | 5}`;
const { tag, size } = defineProps<{
  tag: HeadingTag;
  // Intentionally want undefined as default value.
  // eslint-disable-next-line vue/require-default-prop
  size?: TextSize;
}>();
defineSlots<{ default: () => void }>();

const sizeDefault = match(tag)
  .returnType<TextSize>()
  .with('h1', () => '4xl')
  .with('h2', () => '3xl')
  .with('h3', () => '2xl')
  .with('h4', () => 'xl')
  .with('h5', () => 'lg')
  .exhaustive();
</script>

<template>
  <AppText
    :as="tag"
    :size="size ?? sizeDefault"
    :class="tag === 'h1' ? 'font-semibold' : 'font-medium'"
  >
    <slot />
  </AppText>
</template>
